export const LIST_SCROLL_OFFSET = 120;
export const SOCKET_CONTAINER_WIDTH = { xs: '100%', md: '50%' };
